import { createContext, useContext } from 'react';

export interface MobileMenuContextType {
    isOpen: boolean;
    toggle: () => void;
    close: () => void;
}

export const MobileMenuContext = createContext<MobileMenuContextType | null>(null);

export const useMobileMenu = () => useContext(MobileMenuContext);
